function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;


//////////////////
// WEBPACK FOOTER
// ./~/jss-plugin-vendor-prefixer/~/css-vendor/~/@babel/runtime/helpers/iterableToArray.js
// module id = 1659
// module chunks = 0